import { forwardRef } from 'react';
import TooltipComponent from '../../../utils/TooltipComponent';

const Input = forwardRef(
	(
		{
			placeholder,
			className = '',
			type = 'text',
			name,
			onChange = () => null,
			value,
			error,
			loading,
			tooltip = false,
			wrapperClassname = '',
			...restProps
		},
		ref
	) => {
		return (
			<div
				className={`wp-checkout-form-input-wrapper ${tooltip ? 'has-tooltip' : ''} ${wrapperClassname} ${error ? 'has-errors' : ''}`}
			>
				<input
					ref={ref}
					value={value}
					name={name}
					type={type}
					className={`wp-checkout-font-base wp-checkout-form-control ${className} ${error ? 'has-errors' : ''}`}
					placeholder={loading ? 'Loading...' : placeholder}
					onChange={e => onChange(e.target.value)}
					{...restProps}
				/>

				{error && !tooltip && (
					<p className="wp-checkout-form-input-error wp-checkout-font-sm">
						{error}
					</p>
				)}

				{error && tooltip && (
					<TooltipComponent tooltipText={error}>
						<span
							aria-describedby="button-tooltip"
							className="wp-checkout-react-select-error"
						>
							<i
								className="wpd-icon wpd-information-solid"
								style={{ color: '#FF0000' }}
							></i>
						</span>
					</TooltipComponent>
				)}
			</div>
		);
	}
);

export default Input;
